// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'



//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = store.state.server;
//.AXIOS

//VEE-VALIDATE
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorIt from '@/validator/it';
if (store.state.language == 'it') {
  Validator.localize('it', validatorIt);
}
else {
  Validator.localize('es', validatorEs);
}
// console.log(store.state.language)
Vue.use(VeeValidate);
//.VEE-VALIDATE


//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: store.state.language,
  messages,
  globalInjection: true,
});
//.IDIOMAS
//SCROLLTO

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  offset: -80,
})

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-220430569-1',
  checkDuplicatedScript: true,
  debug: {
    enabled: true
  }

})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  VeeValidate,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js